var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-folder-system',{attrs:{"title":"Онлайн заявки","data-source":_vm.dataSource,"breadcrumbs":_vm.breadcrumbs,"folder-data-source":_vm.folderDataSource}})
}
var staticRenderFns = []

export { render, staticRenderFns }